import { render } from "./NewContact.vue?vue&type=template&id=68a34382"
import script from "./NewContact.vue?vue&type=script&lang=js"
export * from "./NewContact.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__